import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconButton} from '@material-ui/core';
import useStyles from './DialogCloseButtonStyles';
import clsx from 'clsx';

function DialogCloseButton(props) {
  const {className, ...rest} = props;
  const classes = useStyles();

  return (
    <IconButton color="primary" className={clsx(className, classes.closeButtonIcon)} {...rest}>
      <FontAwesomeIcon icon={['fas', 'times-circle']} />
    </IconButton>
  );
}

export default DialogCloseButton;
